function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: 90%;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from 'styled-components';
import { transition, media, fadeOut, fadeIn, easeIn, easeOut, fast, slow } from '../../mixins';
import { transparentize, rem } from 'polished';

var getAlignment = function getAlignment(_ref) {
  var alignment = _ref.alignment,
      variant = _ref.variant;
  var position = variant === 'spinner' ? 'middle' : alignment;
  return "\n    ".concat(position === 'left' ? 'margin: auto 0;' : '', "\n    ").concat(position === 'middle' ? 'margin: auto; text-align: center;' : '', "\n  ");
};

var getAnimation = function getAnimation(closing) {
  return closing ? css(["", " ", " ", ""], fadeOut, easeIn, slow) : css(["", " ", " ", ""], fadeIn, easeOut, fast);
};

export var StyledScrollContainer = styled.div.withConfig({
  displayName: "Modalstyle__StyledScrollContainer",
  componentId: "sc-1u1z7ft-0"
})(["overflow-y:auto;overflow-x:hidden;position:fixed;width:100%;height:100%;"]);
export var StyledModal = styled.div.withConfig({
  displayName: "Modalstyle__StyledModal",
  componentId: "sc-1u1z7ft-1"
})(["background:", ";border:2px solid transparent;border-radius:", ";margin:", " auto;padding:", ";animation:", ";", ";display:block;box-sizing:border-box;position:relative;width:100%;max-width:", "px;min-height:400px;left:0;right:0;opacity:1;box-shadow:0 0 ", " 0 ", ";outline:transparent;", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.modalRadius;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spaces.xlg;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.spaces.xlg;
}, function (_ref6) {
  var beginClose = _ref6.beginClose;
  return getAnimation(beginClose);
}, transition(), function (_ref7) {
  var size = _ref7.size;
  return size === 'large' ? 900 : 600;
}, rem('24px'), function (_ref8) {
  var theme = _ref8.theme;
  return transparentize(0.8, theme.color.black);
}, media.xs(_templateObject()));
export var StyledModalHeader = styled.div.withConfig({
  displayName: "Modalstyle__StyledModalHeader",
  componentId: "sc-1u1z7ft-2"
})(["", " padding-bottom:", ";outline:transparent;"], function (_ref9) {
  var alignment = _ref9.alignment,
      variant = _ref9.variant;
  return getAlignment({
    alignment: alignment,
    variant: variant
  });
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.spaces.lg;
});
export var StyledModalIconContainer = styled.div.withConfig({
  displayName: "Modalstyle__StyledModalIconContainer",
  componentId: "sc-1u1z7ft-3"
})(["margin:auto;text-align:", ";outline:transparent;height:70px;"], function (props) {
  return props.alignment === 'middle' ? 'center' : 'left';
});

var getSmallHeight = function getSmallHeight(_ref11) {
  var size = _ref11.size,
      hasIcon = _ref11.hasIcon,
      variant = _ref11.variant;
  if (size !== 'small' || variant !== 'default') return '';
  return css(["height:", "px;"], hasIcon ? 250 : 320);
};

export var StyledModalContent = styled.div.withConfig({
  displayName: "Modalstyle__StyledModalContent",
  componentId: "sc-1u1z7ft-4"
})(["outline:transparent;", " ", ""], getAlignment, getSmallHeight);
export var StyledSpinnerWrapper = styled.div.withConfig({
  displayName: "Modalstyle__StyledSpinnerWrapper",
  componentId: "sc-1u1z7ft-5"
})(["margin:112px 0;"]);
export var StyledCloseButtonContainer = styled.div.withConfig({
  displayName: "Modalstyle__StyledCloseButtonContainer",
  componentId: "sc-1u1z7ft-6"
})(["margin:0;padding:0;position:absolute;top:", ";right:", ";"], rem('8px'), rem('8px'));
export default StyledModal;